module.exports = __webpack_public_path__ + "img/8.540bcb9a.jpg";